import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { RainbowSoapBlockComponent } from './RainbowSoapBlockComponent';
import { RainbowSoapBlockProps } from './RainbowSoapBlock';

const RainbowSoapBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  RainbowSoapBlockComponent,
);
export type RainbowSoapBlockEntity = EntityType<
  typeof RainbowSoapBlockEntityDef
>;

export function _spawnRainbowSoapBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: BlockProps,
  position: Vector2,
): RainbowSoapBlockEntity {
  // spawn base block
  const entity = _spawnBaseBlockEntity(
    RainbowSoapBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockRainbowSoap: {
        props: props as RainbowSoapBlockProps,
      },
    },
  );

  // build scene
  entity.c.view2d.view.addChild(entity.c.blockRainbowSoap.view);

  return entity;
}
